// React Lib
import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, Popover, Divider } from "@mui/material";
// React Virtualized
import { AutoSizer, List, CellMeasurer, CellMeasurerCache } from "react-virtualized";
// Component Styles
import { useStyles } from "./TourCardStyles";
// Local
import { Group } from "./constants";
// @otg-one/ui_components/components
import { Typography, Tooltip, OverflowMenu, Separator, Tableau } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// @otg-one/ui_components/icons
import { Euro, Navigation, Standby, ArrowHeadRight, Checkmark, Arrival, Alert } from "../../icons";
import { ArrowRight, Close, Location, Pause, ShowMoreHorizontal } from "../../sap_icons";
export const TourCard = (props) => {
    //#region declarations
    const classes = useStyles(props);
    const { data: { id, number, progress, status, driver, codriver, vehicle, price, lastUpdate, currentLoad, capacity, stops, stopsCount, firstKnownPositionAddress }, icon, onClick, menuItems } = props;
    const [totalStops, setTotalStops] = useState(0);
    const [stopChronologies, setStopChronologies] = useState([]);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [detailAnchor, setDetailAnchor] = useState(null);
    const [capacityOpen, setCapacityOpen] = useState(false);
    const [detailOpen, setDetailOpen] = useState(false);
    const cache = useRef(new CellMeasurerCache({
        fixedWidth: true,
        defaultHeight: 100,
    }));
    //#endregion
    useEffect(() => {
        const totalStops = stops.length;
        const newStopChronologies = [...stopChronologies];
        newStopChronologies.push({
            start: firstKnownPositionAddress,
            end: ``,
            status: ``
        });
        if (stops.length > 0) {
            stops.forEach((tourStop, index) => {
                if (index === 0) {
                    newStopChronologies[0].end = tourStop.address;
                    newStopChronologies[0].status = tourStop.status;
                }
                if (index !== stops.length - 1) {
                    newStopChronologies.push({
                        start: stops[index].address,
                        end: stops[index + 1].address,
                        status: stops[index + 1].status
                    });
                }
            });
        }
        setStopChronologies(newStopChronologies);
        setTotalStops(totalStops);
    }, []);
    //#region handlers
    const handleClickShowMore = (event) => {
        event.stopPropagation();
        setMenuAnchor(event.currentTarget);
    };
    const handleDoubleClickTourCard = (event) => {
        if (!detailAnchor) {
            setDetailAnchor(event.currentTarget);
            setDetailOpen(true);
            return;
        }
        setDetailAnchor(null);
        setDetailOpen(false);
    };
    const toggleCapacity = () => {
        setCapacityOpen(!capacityOpen);
    };
    //#endregion
    //#region helpers
    const renderProgress = (stop, index) => {
        console.log(stop);
        const isDelivered = stop.status === 'DELIVERED' || stop.status === 'APPROACHED';
        const isOngoing = stop.status === 'ONGOING';
        const isQueued = stop.status === 'QUEUED';
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.detailTripProgress },
                React.createElement("div", { className: isDelivered ? classes.deliveredCircle
                        : (isOngoing ? classes.ongoingCircle
                            : classes.queuedCircle) },
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, style: { textAlign: 'center' }, color: isQueued ? Color.neutral[900] : Color.neutral[0] }, `${index + 1}`)),
                React.createElement(Tooltip, { title: stop.start !== "" ? stop.start : `No Address` },
                    React.createElement("div", { className: classes.flexStart },
                        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: stop.start !== "" ? Color.neutral[900] : Color.danger[300], size: 14, noWrap: true, style: { width: 140, cursor: 'pointer' } }, stop.start !== "" ? stop.start : `No Address`))),
                React.createElement(ArrowHeadRight, { className: classes.arrowHeadRight }),
                React.createElement(Tooltip, { title: stop.end !== "" ? stop.end : `No Address` },
                    React.createElement("div", { className: classes.flexStart },
                        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: stop.end !== "" ? Color.neutral[900] : Color.danger[300], size: 14, noWrap: true, style: { width: 140, cursor: 'pointer' } }, stop.end !== "" ? stop.end : `No Address`))),
                isDelivered && (React.createElement(Checkmark, { className: classes.checkmark }))),
            isDelivered && (React.createElement("div", { className: classes.flexStart, style: { marginTop: -10 } },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14, style: { marginLeft: 36 } }, `3 hours 23 minutes`),
                React.createElement(Arrival, { className: classes.arrival }),
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14, style: { marginLeft: 7 } }, `12:34 AM`))),
            isOngoing && (React.createElement("div", { className: classes.flexStart, style: { marginTop: -10 } },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14, style: { marginLeft: 36 } }, `1:23:45`))),
            isQueued && (React.createElement("div", { className: classes.flexStart, style: { marginTop: -10 } },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[500], size: 14, style: { marginLeft: 36 } }, `E.D: 1 hours 30 minutes`))),
            index !== totalStops - 1 &&
                React.createElement(Separator, { type: "n200", width: 1, style: { marginTop: 10 } })));
    };
    const getMenus = () => {
        return [
            // {
            //     text: 'Show Tour Details',
            //     onClick: handleDoubleClickTourCard
            // },
            // {
            //     text: 'Show Loading Status',
            //     onClick: toggleCapacity
            // },
            ...menuItems
        ];
    };
    const getWorkstatusIcon = (workstatus) => {
        if (workstatus === "STARTED")
            return React.createElement(Navigation, { className: classes.navigation });
        if (workstatus === "STOPPED")
            return React.createElement(Close, { className: classes.close });
        if (workstatus === "READY")
            return React.createElement(Standby, { className: classes.standby });
        if (workstatus === "PAUSED")
            return React.createElement(Pause, { className: classes.pause });
    };
    //#endregion
    const renderRow = ({ index, key, style, parent }) => {
        const tourStop = stops[index];
        // console.log(tourStop)
        return (React.createElement(CellMeasurer, { key: key, cache: cache.current, parent: parent, columnIndex: 0, rowIndex: index },
            React.createElement("div", { style: Object.assign({ width: '100%', boxSizing: 'border-box', padding: 12 }, style) },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement("div", { className: classes.deliveredCircle },
                        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, style: { textAlign: 'center' }, color: Color.neutral[0] }, `${index + 1}`)),
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[900], size: 14 }, `Stopnummer - ${tourStop.stopNumber} - ${tourStop.address}`)),
                tourStop.orders.map((order) => (React.createElement("div", { style: { marginTop: 12 } },
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.primary[500], size: 14 }, `Order - ${order.orderNumber}`),
                    React.createElement(Divider, { style: { marginTop: 10, marginBottom: 10 } }),
                    order.orderPositions.map((position, positionIndex) => (React.createElement("div", { style: { marginBottom: 12 } },
                        React.createElement(Tableau, { title: position.articleNumber, data: [
                                // { label: 'Artikelnummer', value: position.articleNumber },
                                { label: 'Text', value: position.text },
                                { label: 'Menge', value: `${position.amount} ${position.unit}` }
                            ], showPaper: false }))))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.tourCard, onDoubleClick: handleDoubleClickTourCard, onClick: onClick },
                React.createElement("div", { className: classes.tourRibbon }),
                React.createElement("div", { className: classes.diagramContainer },
                    React.createElement("div", { className: classes.progressContainer },
                        React.createElement(CircularProgress, { className: classes.progressChart, variant: "determinate", value: 100, size: 80 }),
                        React.createElement("div", { className: classes.progessTextContainer },
                            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[400], size: 20 }, `${totalStops}/${totalStops}`),
                            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[400], size: 12 }, 'Stops'))),
                    React.createElement("div", { className: classes.valueContainer }, [1, 2, 3].map((el, index) => (React.createElement(React.Fragment, { key: `euro-indicator-${index}` },
                        React.createElement(Euro, { className: price >= el ? classes.value : classes.valueDisabled })))))),
                React.createElement("div", { className: classes.informationContainer },
                    React.createElement("div", { className: classes.flexSpaceBetween },
                        driver !== '' ? (React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM, color: Color.neutral[500], size: 16 }, `${driver}`)) : (React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM, color: Color.danger[300], size: 16 }, `Unknown Driver`)),
                        React.createElement(ShowMoreHorizontal, { className: classes.showMore, onClick: handleClickShowMore })),
                    React.createElement("div", { className: classes.flexSpaceBetween },
                        React.createElement("div", { className: classes.flexStart },
                            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[600], size: 20 }, `${number}`),
                            vehicle !== '' ? (React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[400], size: 20, style: { paddingLeft: 5 } }, ` (${vehicle})`)) : (React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.danger[300], size: 20, style: { paddingLeft: 5 } }, `( Unknown Vehicle Plate )`))),
                        icon && (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } }, icon))),
                    React.createElement("div", { className: classes.flexStart },
                        React.createElement(Tooltip, { title: progress.fromCity },
                            React.createElement("div", { className: classes.flexStart },
                                getWorkstatusIcon(status),
                                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[600], size: 12, noWrap: true, style: { maxWidth: 75 } }, `${progress.fromCity}`))),
                        React.createElement(ArrowRight, { className: classes.rightArrow }),
                        React.createElement(Tooltip, { title: progress.toCity },
                            React.createElement("div", { className: classes.flexStart },
                                React.createElement(Location, { className: classes.location }),
                                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[600], size: 12, noWrap: true, style: { maxWidth: 75 } }, `${progress.toCity}`))),
                        React.createElement("div", { className: classes.badge },
                            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.primary[900], size: 12, noWrap: true }, `${progress.delay}`))),
                    React.createElement("div", { className: classes.lastUpdate },
                        React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM, color: Color.neutral[400], size: 12 }, `Vor ${lastUpdate} min`))),
                capacityOpen &&
                    React.createElement("div", { className: classes.capacityCard },
                        React.createElement("div", { className: classes.capacityRibbon }),
                        React.createElement("div", { style: { width: '100%' } },
                            React.createElement("div", { className: classes.flexSpaceBetween },
                                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, color: Color.neutral[600], size: 14 }, `Capacity`),
                                React.createElement(Close, { className: classes.closeIcon, onClick: toggleCapacity })),
                            React.createElement("div", null,
                                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, color: Color.neutral[600], size: 20 }, `${currentLoad} Kg`),
                                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[400], size: 12 }, `Available of ${capacity} kg`)),
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.progressBarContainer },
                                    React.createElement("div", { className: classes.progressBarFill }))))))),
        detailOpen &&
            React.createElement(Popover, { open: detailOpen, anchorEl: detailAnchor, onClose: handleDoubleClickTourCard, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } },
                React.createElement("div", { className: classes.detailCard },
                    React.createElement("div", { style: { width: '100%' } },
                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                            React.createElement("div", { style: { display: 'flex' } },
                                React.createElement("div", { style: { marginRight: 15 } },
                                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[500], size: 10 }, `Driver`),
                                    React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, color: Color.neutral[900], size: 24, style: { marginTop: -5 } }, `${driver}`)),
                                React.createElement("div", { style: { marginLeft: 15 } },
                                    React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[500], size: 10 }, `Tour Number`),
                                    React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, color: Color.neutral[900], size: 24, style: { marginTop: -5 } }, `${number}`))),
                            React.createElement(Close, { className: classes.closeIcon, onClick: handleDoubleClickTourCard })),
                        React.createElement("div", null,
                            React.createElement("div", { className: classes.detailContent },
                                React.createElement("div", { style: { position: 'relative' } },
                                    React.createElement("div", { className: classes.detailProgessTextContainer },
                                        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, color: Color.neutral[400], size: 48, style: {
                                                textAlign: 'center',
                                                verticalAlign: 'center'
                                            } }, `${totalStops}/${totalStops}`),
                                        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, color: Color.neutral[400], size: 20, style: {
                                                textAlign: 'center',
                                                verticalAlign: 'center'
                                            } }, 'Stops')),
                                    React.createElement(CircularProgress, { className: classes.progressChart, variant: "determinate", value: 100, size: 250 })),
                                React.createElement("div", { className: classes.detailProgress }, stopChronologies.map((tourStop, index) => (React.createElement(React.Fragment, { key: `stop-indicator-${index}` }, renderProgress(tourStop, index))))))),
                        React.createElement("div", null,
                            React.createElement(Divider, { style: { marginTop: 12, marginBottom: 12 } }),
                            React.createElement("div", { style: { height: 400 } },
                                React.createElement(AutoSizer, null, ({ width, height }) => {
                                    return React.createElement(List, { deferredMeasurementCache: cache.current, width: width, height: height, rowHeight: cache.current.rowHeight, rowRenderer: renderRow, rowCount: stops.length, overscanRowCount: 3 });
                                })))))),
        React.createElement(OverflowMenu, { anchorElement: menuAnchor, setAnchorEl: setMenuAnchor, menuItems: getMenus() })));
};
TourCard.defaultProps = {
    group: Group.FERTIG,
    icon: React.createElement(Alert, { style: { color: Color.danger[800] } }),
    onClick: () => undefined,
    data: {
        number: "4711",
        progress: {
            fromCity: "Werder",
            toCity: "Potsdam",
            delay: "+5 Min"
        },
        status: "STARTED",
        driver: "Commsult",
        codriver: "Indonesia",
        vehicle: "102938",
        firstKnownPositionAddress: "FriedrichStr., Berlin, Deutschland",
        stops: [
            {
                tracesId: "49e725b3-2c32-4203-9b48-140502217aa8",
                orders: [
                    {
                        orderPositions: [
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000001650954",
                                text: "26941",
                                amount: 6,
                                unit: "FAS"
                            },
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000004928861",
                                text: "26939",
                                amount: 15,
                                unit: "KI"
                            }
                        ],
                        tenant: "commsult AG",
                        tourNumber: "8011081019",
                        stopNumber: "0085003975",
                        orderNumber: 85003975,
                        address: {
                            street: "Lennéstraße 37",
                            city: "Potsdam",
                            zipcode: "14469",
                            country: null
                        },
                        customerNumber: null,
                        customerNumberExternal: null,
                        customerText: "0000065073",
                        contractNumber: null,
                        customerLoadingLocation: null
                    }
                ],
                tenant: "commsult AG",
                tourNumber: "8011081019",
                stopNumber: "0085003975",
                stopIndex: 1,
                status: "APPROACHED",
                duration: 10,
                address: "Lennéstraße 37, 14469 Potsdam, Deutschland",
                coordinate: null,
                tourStopNotifications: {
                    eta: "2021-10-27T16:19:33.552924+07:00",
                    notification0: {
                        twStart: "2021-10-27T15:59:33.552924+07:00",
                        twEnd: "2021-10-27T16:59:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: null
                    },
                    notification1: {
                        twStart: "2021-10-27T16:09:33.552924+07:00",
                        twEnd: "2021-10-27T16:39:33.552924+07:00",
                        twStatus: null,
                        twNotificationDate: null
                    },
                    notification2: null,
                    notificationLive: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    },
                    actual: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    }
                },
                durationFromLastStop: 8,
                stopStart: null,
                stopEnd: null,
                stopApproach: "2021-10-27T22:00:30.077+07:00"
            },
            {
                tracesId: "49e725b3-2c32-4203-9b48-140502217aa8",
                orders: [
                    {
                        orderPositions: [
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000000482647",
                                text: "19472",
                                amount: 2,
                                unit: "FAS"
                            },
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000001956297",
                                text: "14826",
                                amount: 8,
                                unit: "FAS"
                            }
                        ],
                        tenant: "commsult AG",
                        tourNumber: "8011081019",
                        stopNumber: "0085003975",
                        orderNumber: 10293847,
                        address: {
                            street: "Lennéstraße 37",
                            city: "Potsdam",
                            zipcode: "14469",
                            country: null
                        },
                        customerNumber: null,
                        customerNumberExternal: null,
                        customerText: "0000065073",
                        contractNumber: null,
                        customerLoadingLocation: null
                    }
                ],
                tenant: "commsult AG",
                tourNumber: "8011081019",
                stopNumber: "0085003975",
                stopIndex: 2,
                status: "APPROACHED",
                duration: 10,
                address: "Zoologischergartenstraße, 10728 Münich, Deutschland",
                coordinate: null,
                tourStopNotifications: {
                    eta: "2021-10-27T16:19:33.552924+07:00",
                    notification0: {
                        twStart: "2021-10-27T15:59:33.552924+07:00",
                        twEnd: "2021-10-27T16:59:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: null
                    },
                    notification1: {
                        twStart: "2021-10-27T16:09:33.552924+07:00",
                        twEnd: "2021-10-27T16:39:33.552924+07:00",
                        twStatus: null,
                        twNotificationDate: null
                    },
                    notification2: null,
                    notificationLive: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    },
                    actual: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    }
                },
                durationFromLastStop: 8,
                stopStart: null,
                stopEnd: null,
                stopApproach: "2021-10-27T22:00:30.077+07:00"
            },
            {
                tracesId: "49e725b3-2c32-4203-9b48-140502217aa8",
                orders: [
                    {
                        orderPositions: [
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000001650954",
                                text: "26941",
                                amount: 6,
                                unit: "FAS"
                            },
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000004928861",
                                text: "26939",
                                amount: 15,
                                unit: "KI"
                            }
                        ],
                        tenant: "commsult AG",
                        tourNumber: "8011081019",
                        stopNumber: "0085003975",
                        orderNumber: 85003975,
                        address: {
                            street: "Lennéstraße 37",
                            city: "Potsdam",
                            zipcode: "14469",
                            country: null
                        },
                        customerNumber: null,
                        customerNumberExternal: null,
                        customerText: "0000065073",
                        contractNumber: null,
                        customerLoadingLocation: null
                    }
                ],
                tenant: "commsult AG",
                tourNumber: "8011081019",
                stopNumber: "0085003975",
                stopIndex: 3,
                status: "APPROACHED",
                duration: 10,
                address: "",
                coordinate: null,
                tourStopNotifications: {
                    eta: "2021-10-27T16:19:33.552924+07:00",
                    notification0: {
                        twStart: "2021-10-27T15:59:33.552924+07:00",
                        twEnd: "2021-10-27T16:59:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: null
                    },
                    notification1: {
                        twStart: "2021-10-27T16:09:33.552924+07:00",
                        twEnd: "2021-10-27T16:39:33.552924+07:00",
                        twStatus: null,
                        twNotificationDate: null
                    },
                    notification2: null,
                    notificationLive: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    },
                    actual: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    }
                },
                durationFromLastStop: 8,
                stopStart: null,
                stopEnd: null,
                stopApproach: "2021-10-27T22:00:30.077+07:00"
            },
            {
                tracesId: "49e725b3-2c32-4203-9b48-140502217aa8",
                orders: [
                    {
                        orderPositions: [
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000001650954",
                                text: "26941",
                                amount: 6,
                                unit: "FAS"
                            },
                            {
                                tenant: "commsult AG",
                                tourNumber: "8011081019",
                                articleNumber: "0085003975000000000000004928861",
                                text: "26939",
                                amount: 15,
                                unit: "KI"
                            }
                        ],
                        tenant: "commsult AG",
                        tourNumber: "8011081019",
                        stopNumber: "0085003975",
                        orderNumber: 85003975,
                        address: {
                            street: "Lennéstraße 37",
                            city: "Potsdam",
                            zipcode: "14469",
                            country: null
                        },
                        customerNumber: null,
                        customerNumberExternal: null,
                        customerText: "0000065073",
                        contractNumber: null,
                        customerLoadingLocation: null
                    }
                ],
                tenant: "commsult AG",
                tourNumber: "8011081019",
                stopNumber: "0085003975",
                stopIndex: 4,
                status: "APPROACHED",
                duration: 10,
                address: "Address 4, 10728 Münich, Deutschland",
                coordinate: null,
                tourStopNotifications: {
                    eta: "2021-10-27T16:19:33.552924+07:00",
                    notification0: {
                        twStart: "2021-10-27T15:59:33.552924+07:00",
                        twEnd: "2021-10-27T16:59:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: null
                    },
                    notification1: {
                        twStart: "2021-10-27T16:09:33.552924+07:00",
                        twEnd: "2021-10-27T16:39:33.552924+07:00",
                        twStatus: null,
                        twNotificationDate: null
                    },
                    notification2: null,
                    notificationLive: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    },
                    actual: {
                        twStart: "2021-10-27T16:19:33.552924+07:00",
                        twEnd: "2021-10-27T16:19:33.552924+07:00",
                        twStatus: 1,
                        twNotificationDate: "2021-10-27T16:11:33.552924+07:00"
                    }
                },
                durationFromLastStop: 8,
                stopStart: null,
                stopEnd: null,
                stopApproach: "2021-10-27T22:00:30.077+07:00"
            }
        ],
        price: 1,
        lastUpdate: 10,
        warningThreshold: 15,
        currentLoad: 500,
        capacity: 1000,
    },
    menuItems: [
        {
            text: 'Show Vehicle on Map',
            onClick: () => { }
        },
        {
            text: 'Show Route on Map',
            onClick: () => { }
        },
        {
            text: 'Send Message to Driver',
            onClick: () => { }
        },
        {
            text: 'Compare Route',
            onClick: () => { }
        }
    ]
};
export default React.memo(TourCard);
